// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar12 from 'assets/images/avatar/avatar-12.jpg';
import Avatar13 from 'assets/images/avatar/avatar-13.jpg';
import Avatar14 from 'assets/images/avatar/avatar-14.jpg';
import Avatar15 from 'assets/images/avatar/avatar-15.jpg';
import Avatar17 from 'assets/images/avatar/avatar-17.jpg';
import Avatar18 from 'assets/images/avatar/avatar-18.jpg';

export const filesdata = [
	{
		id: 1,
		filename: 'Admin-Dashboard-Design.xlsx',
		filesize: '2.3MB',
		date_modified: '27 Sept, 2021',
		avatar: Avatar1,
		uploadedby: 'Paul Haney',
		action: 1
	},
	{
		id: 2,
		filename: 'Admin-Dashboard-Design.jpeg',
		filesize: '10MB',
		date_modified: '29 Sept, 2021',
		avatar: Avatar2,
		uploadedby: 'Dianna Smiley',
		action: 1
	},
	{
		id: 3,
		filename: 'Geeks UI Description.doc',
		filesize: '45MB',
		date_modified: '01 Oct, 2021',
		avatar: null,
		uploadedby: 'Jenny Wilson',
		action: 1
	},
	{
		id: 4,
		filename: 'Geeks-UI-Marketing-Process.ppt',
		filesize: '122MB',
		date_modified: '04 Oct, 2021',
		avatar: Avatar3,
		uploadedby: 'Kristin Watson',
		action: 1
	},
	{
		id: 5,
		filename: 'Geeks-UI-Marketing-Process.txt',
		filesize: '43.5MB',
		date_modified: '06 Oct, 2021',
		avatar: null,
		uploadedby: 'Nia Sikhone',
		action: 1
	},
	{
		id: 6,
		filename: 'Geeks-UI-promo-trailer-template.mov',
		filesize: '115MB',
		date_modified: '08 Oct, 2021',
		avatar: Avatar12,
		uploadedby: 'Jacob Jones',
		action: 1
	},
	{
		id: 7,
		filename: 'Earning-from-Dashboard.xlsx',
		filesize: '55MB',
		date_modified: '12 Oct, 2021',
		avatar: Avatar6,
		uploadedby: 'Kristin Watson',
		action: 1
	},
	{
		id: 8,
		filename: 'Geeks-UI-Marketing-Process.ppt',
		filesize: '122MB',
		date_modified: '04 Oct, 2021',
		avatar: null,
		uploadedby: 'Dianna Smiley',
		action: 1
	},
	{
		id: 9,
		filename: 'Geeks-UI-Marketing-Process.txt',
		filesize: '43.5MB',
		date_modified: '06 Oct, 2021',
		avatar: Avatar13,
		uploadedby: 'Xiaon Merry',
		action: 1
	},
	{
		id: 10,
		filename: 'Admin-Dashboard-Design.jpeg',
		filesize: '10MB',
		date_modified: '16 Nov, 2020',
		avatar: Avatar14,
		uploadedby: 'Rivao Luke',
		action: 1
	},
	{
		id: 11,
		filename: 'Admin-Dashboard-Design.jpeg',
		filesize: '10MB',
		date_modified: '29 Sept, 2021',
		avatar: Avatar15,
		uploadedby: 'Dianna Smiley',
		action: 1
	},
	{
		id: 12,
		filename: 'Admin-Dashboard-Design.xlsx',
		filesize: '55MB',
		date_modified: '16 Nov, 2020',
		avatar: Avatar17,
		uploadedby: 'Nia Sikhone',
		action: 1
	},
	{
		id: 13,
		filename: 'Geeks-UI-Marketing-Process.ppt',
		filesize: '122MB',
		date_modified: '04 Oct, 2021',
		avatar: Avatar18,
		uploadedby: 'Kristin Watson',
		action: 1
	},
	{
		id: 14,
		filename: 'Geeks UI Description.doc',
		filesize: '45MB',
		date_modified: '01 Oct, 2021',
		avatar: Avatar1,
		uploadedby: 'Paul Haney',
		action: 1
	},
	{
		id: 15,
		filename: 'Earning-from-Dashboard.xlsx',
		filesize: '55MB',
		date_modified: '16 Nov, 2020',
		avatar: Avatar2,
		uploadedby: 'Dianna Smiley',
		action: 1
	},
	{
		id: 16,
		filename: 'Admin-Dashboard-Design.jpeg',
		filesize: '10MB',
		date_modified: '16 Nov, 2020',
		avatar: Avatar3,
		uploadedby: 'Kristin Watson',
		action: 1
	},
	{
		id: 17,
		filename: 'Earning-from-Dashboard.xlsx',
		filesize: '55MB',
		date_modified: '29 Sept, 2021',
		avatar: Avatar4,
		uploadedby: 'Nia Sikhone',
		action: 1
	},
	{
		id: 18,
		filename: 'Geeks-UI-Marketing-Process.txt',
		filesize: '43.5MB',
		date_modified: '06 Oct, 2021',
		avatar: Avatar6,
		uploadedby: 'Kristin Watson',
		action: 1
	},
	{
		id: 19,
		filename: 'Geeks-UI-Marketing-Process.ppt',
		filesize: '122MB',
		date_modified: '04 Oct, 2021',
		avatar: Avatar7,
		uploadedby: 'Dianna Smiley',
		action: 1
	},
	{
		id: 20,
		filename: 'Admin-Dashboard-Design.xlsx',
		filesize: '55MB',
		date_modified: '16 Nov, 2020',
		avatar: Avatar12,
		uploadedby: 'Jacob Jones',
		action: 1
	},
	{
		id: 21,
		filename: 'Admin-Dashboard-Design.jpeg',
		filesize: '10MB',
		date_modified: '29 Sept, 2021',
		avatar: Avatar13,
		uploadedby: 'Xiaon Merry',
		action: 1
	},
	{
		id: 22,
		filename: 'Geeks UI Description.doc',
		filesize: '45MB',
		date_modified: '01 Oct, 2021',
		avatar: Avatar14,
		uploadedby: 'Rivao Luke',
		action: 1
	},
	{
		id: 23,
		filename: 'Geeks-UI-Marketing-Process.ppt',
		filesize: '122MB',
		date_modified: '04 Oct, 2021',
		avatar: Avatar15,
		uploadedby: 'Dianna Smiley',
		action: 1
	},
	{
		id: 24,
		filename: 'Admin-Dashboard-Design.xlsx',
		filesize: '55MB',
		date_modified: '16 Nov, 2020',
		avatar: Avatar17,
		uploadedby: 'Nia Sikhone',
		action: 1
	},
	{
		id: 25,
		filename: 'Geeks-UI-promo-trailer-template.mov',
		filesize: '115MB',
		date_modified: '08 Oct, 2021',
		avatar: Avatar18,
		uploadedby: 'Kristin Watson',
		action: 1
	},
	{
		id: 26,
		filename: 'Geeks-UI-Marketing-Process.txt',
		filesize: '43.5MB',
		date_modified: '06 Oct, 2021',
		avatar: Avatar1,
		uploadedby: 'Paul Haney',
		action: 1
	},
	{
		id: 27,
		filename: 'Geeks-UI-promo-trailer-template.mov',
		filesize: '115MB',
		date_modified: '08 Oct, 2021',
		avatar: Avatar2,
		uploadedby: Avatar1,
		action: 1
	},
	{
		id: 28,
		filename: 'Geeks-UI-Marketing-Process.txt',
		filesize: '43.5MB',
		date_modified: '06 Oct, 2021',
		avatar: Avatar3,
		uploadedby: 'Kristin Watson',
		action: 1
	},
	{
		id: 29,
		filename: 'Geeks-UI-Marketing-Process.ppt',
		filesize: '122MB',
		date_modified: '04 Oct, 2021',
		avatar: Avatar4,
		uploadedby: 'Nia Sikhone',
		action: 1
	},
	{
		id: 30,
		filename: 'Admin-Dashboard-Design.xlsx',
		filesize: '55MB',
		date_modified: '12 Oct, 2021',
		avatar: Avatar6,
		uploadedby: 'Kristin Watson',
		action: 1
	}
];

export const FilesData = [filesdata];
